/* Nombra Studio — creador de collar: elige letra/nombre y metal, ve precio y fecha, añade al carrito */
(function () {
  function iniciar(root) {
    var datosEl = root.querySelector('[data-crea-datos]');
    if (!datosEl) return;
    var datos;
    try { datos = JSON.parse(datosEl.textContent); } catch (e) { return; }

    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };
    var img = $('[data-crea-img]');
    var chip = $('[data-crea-chip]');
    var precioEl = $('[data-crea-precio]');
    var fechaEl = $('[data-crea-fecha]');
    var errorEl = $('[data-crea-error]');
    var comprar = $('[data-crea-comprar]');

    var tipo = datos.inicial ? 'inicial' : 'nombre';
    var estado = { inicial: { letra: 'A', metal: null }, nombre: { metal: null, largo: null } };

    function unicos(vars, clave) {
      var vistos = [];
      vars.forEach(function (v) { if (v[clave] && vistos.indexOf(v[clave]) < 0) vistos.push(v[clave]); });
      return vistos;
    }

    function pintarPills(cont, valores, actual, onClick) {
      cont.innerHTML = '';
      valores.forEach(function (val) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nb-crea__pill' + (val === actual ? ' is-activa' : '');
        b.textContent = val;
        b.addEventListener('click', function () { onClick(val); });
        cont.appendChild(b);
      });
    }

    function formatoFecha(f) {
      try { return f.toLocaleDateString('es-ES', { day: 'numeric', month: 'long' }); }
      catch (e) { return f.getDate() + '/' + (f.getMonth() + 1); }
    }

    function varianteActual() {
      var d = datos[tipo];
      if (!d) return null;
      if (tipo === 'inicial') {
        return d.variantes.filter(function (v) { return v.o1 === estado.inicial.metal && v.o2 === estado.inicial.letra; })[0] || null;
      }
      return d.variantes.filter(function (v) { return v.o1 === estado.nombre.metal && v.o2 === estado.nombre.largo; })[0] || null;
    }

    function nombreEscrito() { var i = $('[data-crea-nombre]'); return i ? i.value.trim() : ''; }

    function pintarResumen() {
      var d = datos[tipo];
      var v = varianteActual();
      precioEl.textContent = v ? v.precio : '';
      var hoy = new Date();
      var desde = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() + d.min);
      var hasta = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate() + d.max);
      fechaEl.innerHTML = 'Recíbelo entre el <strong>' + formatoFecha(desde) + '</strong> y el <strong>' + formatoFecha(hasta) + '</strong> (' + d.min + '-' + d.max + ' días)';
      var fotoVariante = (tipo === 'inicial' && img && img.getAttribute('data-fija')) ? img.getAttribute('data-fija') : (v && v.imagen ? v.imagen : d.imagen);
      if (img && fotoVariante) img.src = fotoVariante;
      var partes = [];
      if (tipo === 'inicial') { partes.push('Letra ' + estado.inicial.letra); partes.push(estado.inicial.metal); }
      else { partes.push(nombreEscrito() || 'Tu nombre'); partes.push(estado.nombre.metal); partes.push(estado.nombre.largo); }
      chip.textContent = partes.filter(Boolean).join(' · ');
      comprar.disabled = !v || (v && v.disponible === false);
      var prev = $('[data-crea-preview]'), marco = $('.nb-crea__marco');
      if (prev && marco && window.NBVista) {
        if (tipo === 'nombre') {
          var fsel = $('[data-crea-fuentes] input:checked');
          prev.hidden = false; marco.hidden = true;
          window.NBVista.render(prev, { nombre: nombreEscrito(), fuente: fsel ? fsel.value : 'Rebecca', metal: estado.nombre.metal, longitud: estado.nombre.largo });
        } else { prev.hidden = true; marco.hidden = false; }
      }
      var mini = $('[data-crea-mini]');
      if (mini && window.NBVista && window.NBVista.renderInicial && tipo === 'inicial') window.NBVista.renderInicial(mini, { letra: estado.inicial.letra, metal: estado.inicial.metal });
    }

    function montarOpciones() {
      if (datos.inicial) {
        var ms = unicos(datos.inicial.variantes, 'o1');
        if (!estado.inicial.metal) estado.inicial.metal = ms[0];
        pintarPills($('[data-crea-metales="inicial"]'), ms, estado.inicial.metal, function (val) { estado.inicial.metal = val; montarOpciones(); pintarResumen(); });
      }
      if (datos.nombre) {
        var mn = unicos(datos.nombre.variantes, 'o1');
        var ln = unicos(datos.nombre.variantes, 'o2');
        if (!estado.nombre.metal) estado.nombre.metal = mn[0];
        if (!estado.nombre.largo) estado.nombre.largo = ln[Math.min(1, ln.length - 1)];
        pintarPills($('[data-crea-metales="nombre"]'), mn, estado.nombre.metal, function (val) { estado.nombre.metal = val; montarOpciones(); pintarResumen(); });
        pintarPills($('[data-crea-largos]'), ln, estado.nombre.largo, function (val) { estado.nombre.largo = val; montarOpciones(); pintarResumen(); });
      }
    }

    function cambiarTab(nuevo) {
      tipo = nuevo;
      $$('[data-crea-tab]').forEach(function (b) { b.classList.toggle('is-activa', b.getAttribute('data-crea-tab') === nuevo); });
      $$('[data-crea-pane]').forEach(function (p) { p.hidden = p.getAttribute('data-crea-pane') !== nuevo; });
      errorEl.hidden = true;
      pintarResumen();
    }

    $$('[data-crea-tab]').forEach(function (b) { b.addEventListener('click', function () { cambiarTab(b.getAttribute('data-crea-tab')); }); });
    $$('.nb-crea__letra').forEach(function (b) {
      b.addEventListener('click', function () {
        estado.inicial.letra = b.getAttribute('data-valor');
        $$('.nb-crea__letra').forEach(function (x) { x.classList.toggle('is-activa', x === b); });
        pintarResumen();
      });
    });
    $$('[data-crea-fuentes] input').forEach(function (r) { r.addEventListener('change', pintarResumen); });
    var inputNombre = $('[data-crea-nombre]');
    if (inputNombre) inputNombre.addEventListener('input', pintarResumen);

    comprar.addEventListener('click', function () {
      var v = varianteActual();
      errorEl.hidden = true;
      if (!v) { errorEl.textContent = 'Esa combinación no está disponible.'; errorEl.hidden = false; return; }
      var propiedades = {};
      if (tipo === 'nombre') {
        var nombre = nombreEscrito();
        if (!nombre) { errorEl.textContent = 'Escribe el nombre que quieres en el collar.'; errorEl.hidden = false; if (inputNombre) inputNombre.focus(); return; }
        propiedades['Nombre'] = nombre;
        var f = $('[data-crea-fuentes] input:checked');
        if (!f) { errorEl.textContent = 'Elige un tipo de letra.'; errorEl.hidden = false; var primero = $('[data-crea-fuentes]'); if (primero) primero.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
        propiedades['Tipo de letra'] = f.value;
        propiedades['_Código de letra'] = f.getAttribute('data-codigo') || '';
      }
      comprar.disabled = true;
      var textoOriginal = comprar.textContent;
      comprar.textContent = 'Añadiendo…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: propiedades }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        window.location.href = '/cart';
      }).catch(function () {
        errorEl.textContent = 'No se ha podido añadir. Inténtalo de nuevo o entra en la ficha del producto.';
        errorEl.hidden = false;
        comprar.disabled = false;
        comprar.textContent = textoOriginal;
      });
    });

    montarOpciones();
    pintarResumen();
  }

  function arrancar() { [].slice.call(document.querySelectorAll('[data-nb-crea]')).forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();
